import React from 'react';
import { motion } from 'framer-motion';
import { Users, Languages, MapPin, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const StatisticsSection = () => {
  const { t, language } = useLanguage();

  const stats = [
    { icon: Users, number: '100+', label: 'Families Supported', labelZh: '服务家庭' },
    { icon: Languages, number: 'EN · 中文', label: 'Bilingual Service', labelZh: '中英双语服务' },
    { icon: MapPin, number: 'Sydney', label: 'Local & Trusted', labelZh: '本地信赖' },
    { icon: Award, number: 'Associated', label: 'Aged Care Provider', labelZh: '关联养老服务商' }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex flex-col items-start"
                data-testid={`stat-${index}`}
              >
                <div className="w-12 h-12 rounded-xl bg-eucalyptus-50 flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-eucalyptus-600" />
                </div>
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy-900 mb-1 tracking-tight">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600 font-medium">
                  {language === 'zh' && stat.labelZh ? stat.labelZh : stat.label}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;
